module.exports = __webpack_public_path__ + "static/media/diktat-28.86f7a63c.mp3";